import showdown from 'showdown';

/* @ngInject */
export default function ($scope, $state, $stateParams, $window, toastr, NoticesService, LayoutService) {
	LayoutService.reset();
	LayoutService.setTitle('Notices');

	$scope.notices = null;

	$scope.parseMarkdown = (markdown) => {
		let converter = new showdown.Converter();

		return converter.makeHtml(markdown);
	};

	$scope.refresh = () => {
		NoticesService.getNotViewed()
		              .then((notices) => {
			              $scope.notices = notices.map((notice) => {
				              return {
					              ...notice,
					              viewed: false,
				              };
			              });
		              });
	};

	$scope.countNotViewedNotices = () => {
		return $scope.notices.filter((notice) => {
			return !notice.viewed;
		}).length;
	};

	$scope.markViewed = (noticeId) => {
		const notice = $scope.notices.find((candidate) => {
			return candidate.id === noticeId;
		});

		if (notice) {
			NoticesService.markAsViewed(noticeId, notice.hash);

			notice.viewed = true;
		}

		if ($scope.countNotViewedNotices() === 0) {
			toastr.clear();
			toastr.success('Your acknowledgement has been saved.');

			if ($stateParams.r) {
				$window.location.href = $stateParams.r;
			} else {
				$state.go('splash.home');
			}
		}

		return false;
	};

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/auth/viewNotices/controller.js